import {useState} from 'react'
import {fetchWrapper} from '../utills/fetchWrapper'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createOCAPIFetch} from '../utills/customFetchOCAPI'

const usePasswordResetAction = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const resetPasswordAction = async ({email, newPassword, resetToken = ''}) => {
        setIsLoading(true)
        setError(null)

        try {
            const accessToken = await new Promise((resolve, reject) => {
                fetchWrapper('/api/auth/password-reset-token', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(async (response) => {
                        if (response.status !== 200) {
                            reject(
                                new Error(
                                    `Failed to fetch password reset token. Status: ${response.status}`
                                )
                            )
                            return
                        }

                        const contentType = response.headers.get('content-type')
                        if (!contentType || !contentType.includes('application/json')) {
                            const responseText = await response.text()
                            reject(
                                new Error(
                                    `API returned HTML instead of JSON. Check if /api/password-reset-token endpoint is working in dev.`
                                )
                            )
                            return
                        }

                        return response.json()
                    })
                    .then((data) => {
                        if (data && data.data && data.data.access_token) {
                            resolve(data.data.access_token)
                        } else {
                            reject(new Error('Invalid token response format'))
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })

            const {app: appConfig} = getConfig()

            const body = {
                login: email,
                new_password: newPassword,
                reset_token: resetToken
            }

            const args = [
                {
                    headers: {
                        'x-dw-client-id': appConfig.ocapiAPI.contentAPIKey,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            ]

            const customFetch = createOCAPIFetch(appConfig, 'customers/password/actions/reset')
            const response = await customFetch('POST', args, body)

            if (response.status && response.status >= 400) {
                const error = new Error(`Password reset failed with status ${response.status}`)
                error.response = response
                throw error
            }

            return response
        } catch (err) {
            setError(err)
            throw err
        } finally {
            setIsLoading(false)
        }
    }

    return {
        resetPasswordAction,
        isLoading,
        error
    }
}

export {usePasswordResetAction}
